"use client";
import type { Schema } from "next-safe-action/adapters/types";
import { type HookSafeActionFn, useAction } from "next-safe-action/hooks";
import { useGenericError } from "~/hooks/useGenericError";

export function useBetterAction<
	ServerError extends string | undefined,
	S extends Schema | undefined,
	const BAS extends readonly Schema[],
	CVE,
	CBAVE,
	Data,
>(safeActionFn: HookSafeActionFn<ServerError, S, BAS, CVE, CBAVE, Data>) {
	const onError = useGenericError();

	return useAction(safeActionFn, { onError: (args) => onError(args.error.serverError) });
}
